import { render, staticRenderFns } from "./InstagramPostCard.vue?vue&type=template&id=77bf399f&scoped=true&"
import script from "./InstagramPostCard.vue?vue&type=script&lang=js&"
export * from "./InstagramPostCard.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPostCard.vue?vue&type=style&index=0&id=77bf399f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf399f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VExpandTransition,VIcon,VSlideYTransition,VSlider,VTextField})
